export const tableLayout = {
  en: [
    {
      width: 240,
      label: "Queue ID",
      dataKey: "id",
    },
    {
      width: 200,
      label: "Action",
      dataKey: "action",
      type: "map",
      hashmap: {
        0: {
          value: "Article Creator",
        },
        1: {
          value: "Homepage Republisher",
        },

        2: {
          value: "Page Publisher",
        },
        3: {
          value: "Video Article Creator",
        },
        4: {
          value: "Video Optimiser",
        },
        5: {
          value: "RankLens",
        },
        6: {
          value: "Reframer Re-render",
        },
        7: {
          value: "Overlay Apply",
        },
        8: {
          value: "TrendScout Refresh",
        },
        9: {
          value: "TrendScout Article",
        },
        10: {
          value: "Today Before Article",
        },
      },
    },
    {
      width: 140,
      label: "Created At",
      dataKey: "createdAt",
      type: "date",
    },
    {
      width: 120,
      label: "Status",
      dataKey: "status",
      type: "map",
      hashmap: {
        0: {
          value: "Pending",
        },
        1: {
          value: "In Progress",
          color: "warning",
        },
        2: {
          value: "Completed",
          color: "success",
        },
        3: {
          value: "Failed",
          color: "error",
        },
      },
    },
    {
      width: 140,
      label: "Actions",
      dataKey: "actions",
      type: "actions",
    },
  ],
  heb: [
    {
      width: 240,
      label: "מזהה תור",
      dataKey: "id",
    },
    {
      width: 200,
      label: "פעולה",
      dataKey: "action",
      type: "map",
      hashmap: {
        0: {
          value: "יצירת מאמר",
        },
        1: {
          value: "מחדש תוכן בעמוד הבית",
        },

        2: {
          value: "מפרסם עמוד",
        },
        3: {
          value: "יוצר מאמרי וידאו",
        },
        4: {
          value: "ממטב וידאו",
        },
        5: {
          value: "RankLens",
        },
        6: {
          value: "רינדור מחדש של ריפריים",
        },
        7: {
          value: "החלת אוברליי",
        },
        8: {
          value: "סריקת TrendScout",
        },
        9: {
          value: "כתבה מ-TrendScout",
        },
        10: {
          value: "כתבה מ׳היום לפני׳",
        },
      },
    },
    {
      width: 140,
      label: "נוצר בתאריך",
      dataKey: "createdAt",
      type: "date",
    },
    {
      width: 120,
      label: "סטטוס",
      dataKey: "status",
      type: "map",
      hashmap: {
        0: {
          value: "ממתין",
        },
        1: {
          value: "בעבודה",
          color: "warning",
        },
        2: {
          value: "הושלם",
          color: "success",
        },
        3: {
          value: "נכשל",
          color: "error",
        },
      },
    },
    {
      width: 140,
      label: "פעולות",
      dataKey: "actions",
      type: "actions",
    },
  ],
};
